import { useStore } from './useStore'

/** The single global switch for the ≥model-floor cutoff. Flip to false to disable everywhere. */
export const MODEL_FLOOR_ENABLED = true

/** Pure: raise an ISO `from` (yyyy-MM-dd) up to the floor. No-op if disabled, floor null,
 *  or already ≥ floor. ISO dates compare lexically. */
export function clampFromToFloor(fromIso: string, floorIso: string | null): string {
  if (!MODEL_FLOOR_ENABLED || !floorIso) return fromIso
  return fromIso < floorIso ? floorIso : fromIso
}

/** Non-React accessor for the endpoint layer (walks.ts). */
export function getModelFloorIso(): string | null {
  return useStore.getState().system.modelFloorIso
}

/** React selector for the preset + date-picker. */
export function useModelFloorIso(): string | null {
  return useStore((s) => s.system.modelFloorIso)
}
